/* fx-email.js — assembles spam-protected e-mail links (see snippets/fx-email).
   Markup: <a class="fx-email" data-fxe-u="<user reversed>" data-fxe-d="<domain reversed>"
             [data-fxe-tpl="Text with [email]"] [data-fxe-keep]>fallback</a>
   - sets href="mailto:…"
   - writes the address into the element carrying [data-fxe-label] (or the
     link itself); data-fxe-tpl replaces [email] inside a longer label;
     data-fxe-keep leaves the visible text untouched (icon-only links). */
(function () {
  'use strict';
  if (window.__fxEmail) return;
  window.__fxEmail = true;

  function rev(s) { return String(s || '').split('').reverse().join(''); }

  function run() {
    var links = document.querySelectorAll('.fx-email[data-fxe-u][data-fxe-d]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.getAttribute('data-fxe-done') === '1') return;
      a.setAttribute('data-fxe-done', '1');
      var addr = rev(a.getAttribute('data-fxe-u')) + '@' + rev(a.getAttribute('data-fxe-d'));
      a.setAttribute('href', 'mailto:' + addr);
      if (a.hasAttribute('data-fxe-keep')) return;
      var label = a.querySelector('[data-fxe-label]') || a;
      var tpl = label.getAttribute('data-fxe-tpl') || a.getAttribute('data-fxe-tpl');
      label.textContent = tpl ? tpl.replace('[email]', addr) : addr;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
